// eslint-disable-next-line import/no-unresolved
import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class MediaCollage extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="media-collage.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="media-collage.slide"]')
    this.controlPrevEls = this.querySelectorAll(
      '[data-el="media-collage.controlprevious"]'
    )
    this.controlNextEls = this.querySelectorAll(
      '[data-el="media-collage.controlnext"]'
    )

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()

    this.controlPrevEls.forEach(controlPrevEl => {
      controlPrevEl.addEventListener('click', this.onNavClick.bind(this))
    })

    this.controlNextEls.forEach(controlNextEl => {
      controlNextEl.addEventListener('click', this.onNavClick.bind(this))
    })
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new keenSlider(this.slidesEl, {
      duration: 0,
      loop: true,
      slides: this.slideEls.length,
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      },
      move: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide
          )
        })
      },
    })
  }

  onNavClick (event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('media-collage', MediaCollage)
